// Status configuration + helpers

export const LEAD_STATUSES = [
  { value: "new", label: "New", cls: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800", dot: "bg-blue-500" },
  { value: "no_answer", label: "No Answer", cls: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-800", dot: "bg-amber-500" },
  { value: "call_back", label: "Call Back", cls: "bg-cyan-100 text-cyan-700 border-cyan-200 dark:bg-cyan-900/30 dark:text-cyan-400 dark:border-cyan-800", dot: "bg-cyan-500" },
  { value: "not_interested", label: "Not Interested", cls: "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-900/30 dark:text-rose-400 dark:border-rose-800", dot: "bg-rose-500" },
  { value: "wrong_information", label: "Wrong Info", cls: "bg-orange-100 text-orange-700 border-orange-200 dark:bg-orange-900/30 dark:text-orange-400 dark:border-orange-800", dot: "bg-orange-500" },
  { value: "investment", label: "Investment", cls: "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-800", dot: "bg-emerald-500" },
  { value: "no_language", label: "No Language", cls: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700", dot: "bg-slate-400" },
  { value: "duplicate", label: "Duplicate", cls: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700", dot: "bg-slate-400" },
];

export const CLIENT_STATUSES = [
  { value: "in_progress", label: "In Progress", cls: "bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-400 dark:border-purple-800", dot: "bg-purple-500" },
  { value: "pending", label: "Pending", cls: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-800", dot: "bg-amber-500" },
  { value: "deposit", label: "Deposit", cls: "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-800", dot: "bg-emerald-500" },
  { value: "not_interested", label: "Not Interested", cls: "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-900/30 dark:text-rose-400 dark:border-rose-800", dot: "bg-rose-500" },
  { value: "done", label: "Done", cls: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800", dot: "bg-blue-500" },
  { value: "investment", label: "Investment", cls: "bg-cyan-100 text-cyan-700 border-cyan-200 dark:bg-cyan-900/30 dark:text-cyan-400 dark:border-cyan-800", dot: "bg-cyan-500" },
];

export function statusMeta(type, value) {
  const list = type === "lead" ? LEAD_STATUSES : CLIENT_STATUSES;
  return list.find((s) => s.value === value) || { value, label: value || "—", cls: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700", dot: "bg-slate-400" };
}

export const ROLE_META = {
  admin: { label: "admin", cls: "bg-indigo-100 text-indigo-700 border-indigo-200 dark:bg-indigo-500/15 dark:text-indigo-300 dark:border-indigo-800" },
  team_leader: { label: "team leader", cls: "bg-violet-100 text-violet-700 border-violet-200 dark:bg-violet-500/15 dark:text-violet-300 dark:border-violet-800" },
  agent: { label: "agent", cls: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700" },
};

const COUNTRY_NAMES = {
  AT: "Austria", BE: "Belgium", CA: "Canada", CH: "Switzerland", CY: "Cyprus", CZ: "Czechia",
  DE: "Germany", DK: "Denmark", EE: "Estonia", ES: "Spain", FI: "Finland", FR: "France",
  GB: "United Kingdom", GR: "Greece", HR: "Croatia", HU: "Hungary", IE: "Ireland", IT: "Italy",
  LU: "Luxembourg", NL: "Netherlands", NO: "Norway", NZ: "New Zealand", PL: "Poland", PT: "Portugal",
  RO: "Romania", SE: "Sweden", SG: "Singapore", SI: "Slovenia", SK: "Slovakia", US: "United States",
  AU: "Australia", ZA: "South Africa", AE: "UAE", IN: "India",
};

export function countryName(code) {
  if (!code) return "—";
  return COUNTRY_NAMES[code.toUpperCase()] || code;
}

export function countryFlag(code) {
  if (!code || code.length !== 2) return "🌐";
  const cc = code.toUpperCase();
  if (!/^[A-Z]{2}$/.test(cc)) return "🌐";
  return String.fromCodePoint(...[...cc].map((c) => 127397 + c.charCodeAt(0)));
}

export function money(n) {
  return "$" + (Number(n) || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
}

export function initials(name) {
  if (!name) return "?";
  return name.trim().split(/\s+/).slice(0, 2).map((p) => p[0]).join("").toUpperCase();
}
